import { Injectable, inject } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router} from '@angular/router';
import {AuthService} from './auth.service';
import {catchError, Observable, of} from "rxjs";
import {map} from "rxjs/operators";
import {AuthorityEnum} from "./authority-enum.model";


@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {
  private appRoles = inject(AuthService);
  private _router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requiredRoles = route.data['roles'] as AuthorityEnum[];

    const currentRoles: string[] = this.appRoles.roles.value;
    const storedRoles: string[] = this.appRoles.getStoredRoles();

    if (currentRoles.length > 1 || (storedRoles && storedRoles.length > 0)) {
      const userRoles: string[] = currentRoles.length > 1 ? currentRoles : storedRoles;
      this.appRoles.roles.next(userRoles);

      const isAuthorized: boolean = requiredRoles.some(role => userRoles.includes(role));
      if (!isAuthorized) this._router.navigate(['app', 'error']);
      return of(isAuthorized);
    }

    return this.appRoles.setAppAuthRolesAndGetRoles().pipe(
      map((fetchedRoles: string[]) => {
        const isAuthorized: boolean = requiredRoles.some(role => fetchedRoles.includes(role));
        if (!isAuthorized) this._router.navigate(['app', 'error']);
        return isAuthorized;
      }),
      catchError(() => {
        this._router.navigate(['app', 'error']);
        return of(false);
      })
    );
  }

}
